var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKinlyAltlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "35px",
    viewBox: "0 0 110 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E37AF46C-0B08-4C17-85A0-231756CB3F4E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0578655462 0.383646667 16.6035294 0.383646667 16.6035294 21.21238 0.0578655462 21.21238"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.0781666667 9.54823109 0.0781666667 9.54823109 33.8214333 0 33.8214333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.304903361 0.300066667 22.7005336 0.300066667 22.7005336 34.5333097 0.304903361 34.5333097"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kinly_Summary-2",
    transform: "translate(-85.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SideNav",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kinly_logo",
    transform: "translate(85.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4419412,28.28098 C55.4419412,28.28098 51.0604286,21.7817133 49.1308067,18.9224467 L46.0244622,22.5615133 L46.0244622,28.28098 L41.7737479,28.28098 L41.7737479,6.64024667 L46.0244622,6.64024667 L46.0244622,17.6881133 L55.1803445,6.64024667 L60.2486639,6.64024667 L52.1391681,15.9656467 C52.7279916,16.8425133 53.4799664,17.94758 54.4283697,19.3452467 C55.3763109,20.7424467 56.2923613,22.10698 57.1751345,23.4393133 C58.0579076,24.77118 58.8426975,25.9089133 59.4966891,26.8511133 C60.1178655,27.79378 60.4446303,28.28098 60.4446303,28.28098 L55.4419412,28.28098 Z",
    id: "Fill-1",
    fill: "#280b56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0469328,9.88918 L66.2981092,9.88918 L66.2981092,6.47738 L62.0469328,6.47738 L62.0469328,9.88918 Z M62.144916,28.2805133 L66.1668487,28.2805133 L66.1668487,12.68358 L62.144916,12.68358 L62.144916,28.2805133 Z",
    id: "Fill-3",
    fill: "#280b56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6652185,12.6836267 L73.0659748,12.6836267 L73.4255546,15.6086933 C74.7663529,13.6906933 76.4995462,12.32616 79.2134958,12.32616 C82.4506387,12.32616 84.4449664,14.47096 84.4449664,17.75256 L84.4449664,28.28056 L80.4230336,28.28056 L80.4230336,18.4026267 C80.4230336,16.68016 79.4750924,15.51116 77.6111008,15.51116 C76.4667311,15.51116 75.5511429,15.9008267 74.7991681,16.64796 C74.0467311,17.42776 73.6871513,18.2728933 73.6871513,19.14976 L73.6871513,28.28056 L69.6652185,28.28056 L69.6652185,12.6836267 Z",
    id: "Fill-4",
    fill: "#280b56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#280b56",
    points: "87.5992857 28.28098 91.6212185 28.28098 91.6212185 6.53804667 87.5992857 6.53804667"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 0.166647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(93.361345, 12.133333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0578655462,0.383646667 L4.24341176,0.383646667 L8.49412605,11.8538467 L8.52694118,11.8538467 L12.5816891,0.383646667 L16.6036218,0.383646667 L10.7176975,15.20078 C8.9845042,19.4577133 7.64416807,21.21238 3.19702521,21.21238 L1.6602605,21.21238 L1.6602605,18.28778 L2.24862185,18.28778 C4.34139496,18.28778 5.45341176,17.80058 6.00895798,16.3380467 L6.27055462,15.7206467 L0.0578655462,0.383646667 Z",
    id: "Fill-7",
    fill: "#280b56",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.466667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95155042,33.8214333 L0.596634454,33.8214333 C0.267096639,33.8214333 -4.62184874e-05,33.5517 -4.62184874e-05,33.2189667 L-4.62184874e-05,0.680633333 C-4.62184874e-05,0.3479 0.267096639,0.0781666667 0.596634454,0.0781666667 L8.95155042,0.0781666667 C9.28108824,0.0781666667 9.54823109,0.3479 9.54823109,0.680633333 L9.54823109,33.2189667 C9.54823109,33.5517 9.28108824,33.8214333 8.95155042,33.8214333",
    id: "Fill-10",
    fill: "#280b56",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(9.243697, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0808277,34.3555333 C17.3521303,34.6299333 17.8096933,34.5804667 18.0098193,34.2500667 C20.9853655,29.3496 22.7005336,23.5858 22.7005336,17.416 C22.7005336,11.2471333 20.9853655,5.48333333 18.0102815,0.583333333 C17.8096933,0.252933333 17.3521303,0.203466667 17.0812899,0.4774 L0.304903361,17.4164667 L17.0808277,34.3555333 Z",
    id: "Fill-13",
    fill: "#C2EDFA",
    mask: "url(#mask-6)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinlyAltlogo);
export default __webpack_public_path__ + "static/media/kinly-alt.logo.2440f8bceea3260f88f414e1003e1687.svg";
export { ForwardRef as ReactComponent };